import {
  _hub_exp_expId,
  _hub_exp_speedMapping,
  _hub_exp_thisTask,
} from '../components/hub'
import { enableSocket } from '../constants'
import { joinTextArray } from '../scripts/text'
import { getTouchPosition } from '../scripts/utils'
import { currentVersion, socket } from '../socket'

const lastMove = { current: null }

export const sendData = (
  eventName,
  e,
  { touchSpeed, touchTarget, selectionArray, textArray }
) => {
  // Playground
  if (_hub_exp_thisTask.taskType === -1 || !enableSocket) return
  // if (!enableSocket) return

  const stamp = performance.now()
  const t = new Date()

  let touch
  if (e) touch = getTouchPosition(e)
  else touch = [-1, -1]

  if (touch[0] === 0 && touch[1] === 0) {
    touch[0] = lastMove.current[0]
    touch[1] = lastMove.current[1]
  } else {
    lastMove.current = touch
  }

  let selection =
    typeof selectionArray === 'string'
      ? selectionArray
      : joinTextArray(selectionArray, true)

  let text =
    typeof textArray === 'string' ? textArray : joinTextArray(textArray)

  if (text === _hub_exp_thisTask.originalText) text = ''

  if (enableSocket)
    socket.emit('sendData', {
      event: eventName,
      experimenterId: _hub_exp_expId.current,
      speedMapping: _hub_exp_speedMapping.current,
      timestamp: stamp,
      dateValues: [
        t.getFullYear(),
        t.getMonth() + 1,
        t.getDate(),
        t.getHours(),
        t.getMinutes(),
        t.getSeconds(),
        t.getMilliseconds(),
      ],
      touchX: Math.round(touch[0]),
      touchY: Math.round(touch[1]),
      touchSpeed: touchSpeed,
      touchTarget: touchTarget,
      text: text,
      selection: selection,
      taskType: _hub_exp_thisTask.taskType,
      taskId: _hub_exp_thisTask.taskId,
      version: currentVersion,
    })
}
